import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";
import SetPasswordPage from "./SetPasswordPage";

createRoot(document.getElementById("ahg-set-password")).render(
	<StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<SetPasswordPage />
		</ThemeProvider>
	</StrictMode>
);
